import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { BottomSheet } from "@/components/BottomSheet";

export const ROOM_AMENITY: Record<string, string> = {
  ac: "AC", attached_bath: "Attached bathroom", balcony: "Balcony", wifi: "Wi-Fi",
  geyser: "Geyser", wardrobe: "Wardrobe", study_table: "Study table", window: "Window",
};

export function RoomAmenityChips({ items, testId }: { items?: string[]; testId: string }) {
  if (!items?.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {items.map((a) => <span key={a} className="text-[11px] font-semibold rounded-full bg-[#e8f1fb] text-[#131e2e] px-2 py-0.5">{ROOM_AMENITY[a] || a}</span>)}
    </div>
  );
}

export function RoomAmenitiesSheet({ room, onClose, onSaved }: { room: any; onClose: () => void; onSaved: () => void }) {
  const [sel, setSel] = useState<string[]>([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (room) setSel(room.amenities || []); }, [room]);
  const toggle = (k: string) => setSel((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]));
  const save = async () => {
    setBusy(true);
    try { await api.patch(`/rooms/${room.id}`, { amenities: sel }); toast.success("Room features saved"); onSaved(); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <BottomSheet open={!!room} onOpenChange={(o) => !o && onClose()} title="Room features" description={room ? `Room ${room.name}` : ""} testId="room-amenities-sheet">
      <div className="flex flex-wrap gap-2 mb-5">
        {Object.entries(ROOM_AMENITY).map(([k, label]) => {
          const on = sel.includes(k);
          return (
            <button key={k} type="button" data-testid={`room-amenity-${k}`} onClick={() => toggle(k)}
              className={`h-11 px-4 rounded-full border text-sm font-semibold pg-tap flex items-center gap-1.5 ${on ? "bg-emerald-500 border-emerald-500 text-white" : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"}`}>
              {on && <Check className="h-4 w-4" />}{label}
            </button>
          );
        })}
      </div>
      <Button data-testid="room-amenities-save-btn" disabled={busy} onClick={save} className="w-full h-14 rounded-xl text-base bg-emerald-700 hover:bg-emerald-800">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Save features"}
      </Button>
    </BottomSheet>
  );
}
